import { useSelector } from "react-redux";

export const useAgentList = () => useSelector((state) => state.dashboard.agentList);
export const useDateRange = () => useSelector((state) => state.dashboard.dateRange);
